import { ReactNode } from "react";
import { Box } from "@mui/material";

interface SplitLabelProps {
	left: ReactNode
	right: ReactNode
}

const SplitLabel = (props: SplitLabelProps) => {
	return (
		<Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
			{props.left}
			{props.right}
		</Box>
	);
};

export default SplitLabel;
